<template>
  <div
    :id="`ss-sw-${slug}`"
    class="ss-opt"
    :class="{ 'is-on': on, 'is-changed': isChanged, 'is-flash': flashing }"
  >
    <div class="ss-opt__h" @click="flip">
      <span class="ss-opt__i"><v-icon size="20">{{ icon }}</v-icon></span>
      <div class="ss-opt__t">
        <b>{{ title }}</b>
        <span>{{ desc }}</span>
      </div>
      <ui-switch tone="accent" :value="Boolean(on)" :label="title" @input="flip" />
    </div>
    <div v-if="on && $slots.default" class="ss-opt__b"><slot></slot></div>
  </div>
</template>

<script>
import hasSettingsField from "./hasSettingsField";

/** Opcija sa ikonom i prekidačem; kad je uključena, otvara dodatna polja. */
export default {
  name: "SetOption",
  mixins: [hasSettingsField],
  props: {
    icon: { type: String, required: true },
    title: { type: String, required: true },
    desc: { type: String, default: "" },
  },
  computed: {
    on() {
      return Boolean(this.value);
    },
  },
  methods: {
    flip() {
      this.write(!this.on, false);
    },
  },
};
</script>
